export default {
  name: "pro-tree-icon",
  props: {
    visible: {
      type: Boolean,
      default() {
        return false;
      }
    },
    expand: {
      type: Boolean,
      default() {
        return false;
      }
    }
  },
  methods: {
    onChange() {
      this.$emit("onChange");
    }
  }
};